(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHero(hero) {
    if (hero.dataset.cbHeroReady === 'true') return;
    hero.dataset.cbHeroReady = 'true';

    const button = hero.querySelector('.cb-editorial-hero__motion');
    const desktopVideo = hero.querySelector('.cb-hero-video--desktop');
    const mobileVideo = hero.querySelector('.cb-hero-video--mobile');
    if (!button || !desktopVideo || !mobileVideo) return;

    let pausedByUser = reducedMotion.matches;

    function sync() {
      const activeVideo = mobile.matches ? mobileVideo : desktopVideo;
      const inactiveVideo = mobile.matches ? desktopVideo : mobileVideo;
      inactiveVideo.pause();

      const shouldPlay = !pausedByUser && !document.hidden;
      if (shouldPlay) {
        const playAttempt = activeVideo.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(() => {
            button.classList.remove('is-playing');
            button.setAttribute('aria-label', 'Play background video');
          });
        }
      } else {
        activeVideo.pause();
      }

      button.classList.toggle('is-playing', shouldPlay);
      button.setAttribute('aria-label', shouldPlay ? 'Pause background video' : 'Play background video');
    }

    button.addEventListener('click', () => {
      pausedByUser = !pausedByUser;
      sync();
    });
    mobile.addEventListener('change', sync);
    reducedMotion.addEventListener('change', () => {
      pausedByUser = reducedMotion.matches;
      sync();
    });
    document.addEventListener('visibilitychange', sync);
    sync();
  }

  function initAll(container = document) {
    container.querySelectorAll('.cb-editorial-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
